// seteamos el store.
// creamos el rootreducer en la carpeta reduccer
import{createStore, applyMiddleware } from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from '../reduccer';

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))

